<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5">
  <img class="adf-img-logo ng-star-inserted" alt="Alden logo" src="assets/alden-extension/images/Alden.svg">
  <b>{{aldenVersion}}</b>
</div>
<mat-dialog-content>
  <div class="spinner-center loading adf-login-card-wide" *ngIf="loading">
    <span class="mb20">Configurando el perfil...</span>
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="!loading">
    <h3 *ngIf="version" class="mb5">{{client | titlecase }} v{{version}}</h3>
    <span *ngIf="versionDesc">{{versionDesc}}</span>

    <mat-card *ngIf="isAdmin">
      <mat-card-content>
        <adf-about></adf-about>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>